import { resolve } from "core-js/fn/promise";
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter)

const routes = [
    {
        path: "/head",
        component: () => import('@/components/Head.vue')
    },
    {
        path: "/main",
        component: () => import('@/components/RightBody.vue')
    },
    {
        path: "/about",
        component: () => import('@/views/AboutView.vue')
    },
    {
        path: "/",
        component: () => import('@/views/HomeView.vue')
    },
    {
        path: "*",
        redirect: '/Home'
    },
]

const router = new VueRouter({
    model:history,
    routes
})

export default router